import type { ApiError } from '@/types/errors/apiError'
import axios from 'axios'

export function handleApiError(error: unknown, activateLog: boolean = true): ApiError {
  if (activateLog) {
    console.error('API Error:', error)
  }

  if (axios.isAxiosError(error)) {
    const responseData = error.response?.data

    if (typeof responseData === 'string') {
      return {
        message: responseData,
        status: error.response?.status ?? 500,
      }
    }

    return {
      message: responseData?.message ?? error.message,
      status: error.response?.status ?? 500,
      errors: responseData?.errors,
    }
  }

  if (error instanceof Error) {
    return {
      message: error.message,
      status: 500,
    }
  }

  return {
    message: 'An unknown error occurred',
    status: 500,
  }
}
